export const cacheKeys = {
  getUniversity: 'getUniversity',
  getUniversities: 'getUniversities',
  likeUniversity: 'likeUniversity',
  unlikeUniversity: 'unlikeUniversity',
  ignoreUniversity: 'ignoreUniversity',
  applyToUniversity: 'applyToUniversity',
  getUniversitySpecialization: 'getUniversitySpecialization',
};
